<template>
  <!-- v-loading.fullscreen.lock="!isShow" -->
  <div class="">
    <div class="row" v-for="(item, i) in list" :key="i">
      <el-alert v-if="item.day" :title="`${text}时间 ${item.day}`" type="info" show-icon :closable="false"></el-alert>
      <!-- {{ item }} -->
      <div v-if="item.noteCount" class="top mb">共{{item.noteCount}}个笔记</div>
      <GuidelineList v-if="category" :class="['mt20', {mt0: item.noteCount }]" :list="setkey(item.subList)" :isShowIndex="false" />
      <article-list v-else :isIndex="false" :class="[{mt0: item.noteCount }]" :honDocuList="setkey(item.subList)" />
    </div>
    <LoadMore v-if="!isShow" @load="onMoreLoad" />
    <placeholder :isShow="isEmpty" />
  </div>
</template>

<script>
import GuidelineList from '@/views/guideline/components/list.vue'
import LoadMore from '@c/loadMore/index.vue'
export default {
  props: {
    text: {
      type: String,
      default: '下载'
    },
    list: {
      type: Array,
      default: () => []
    },
    category: {
      type: Number,
      default: 0
    },
    onMoreLoad: {
      type: Function,
      default: () => {}
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  components: {
    GuidelineList,
    LoadMore
  },
  data () {
    return {
      page: {
        pageNum: 1,
        pageSize: 10
      },
      isEmpty: false,
      loading: false
    }
  },
  methods: {
    // load () {
    //   if (this.loading) return
    //   this.page.pageNum++
    //   // this.getList()
    // },
    // 还原驼峰
    setkey (arr) {
      return arr.map(item => {
        const keyArr = Object.keys(item).map(item => (item.split('_').map(item => (item.charAt(0).toUpperCase() + item.slice(1)))).join('')).map(item => (item.charAt(0).toLowerCase() + item.slice(1)))
        const valArr = Object.values(item)
        const obj = {}
        keyArr.forEach((item, i) => {
          obj[item] = valArr[i]
        })
        return obj
      })
    }
    // async getList () {
    //   try {
    //     this.loading = true
    //     const { data } = await guideline.guidDownloadList(this.page)
    //     this.list = []
    //     this.isEmpty = this.list.length === 0
    //     this.finished = this.list.length === 0
    //   } catch (error) {

    //   } finally {
    //     this.loading = false
    //   }
    // }
  },
  created () {
    // this.getList()
  }
}
</script>

<style lang="less" scoped>
.row:first-of-type{
  padding-top: 8px;
}
.el-alert {
  position: relative;
  background-color: #f5f7fb;
  padding: 0 10px;
  /deep/.el-alert__title {
    font-size: 14px;
  }
}
.top {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  padding-left: 20px;
  color: #000;
  background-color: #d7dce9;
  border-radius: 8px 8px 0 0;
}
.mt0{
  margin-top: 0;
}

</style>
